import React from 'react'
import { Link } from 'react-router';
import Header from '../Header';
import Sidebar from '../Sidebar';

export default function ViewVendor() {


  return (
 <div id="dashboard-root" 
               className="flex min-h-[1000px] w-full">
                 {/* <!-- Sidebar --> */}
                 <Sidebar />
                 {/* <!-- Main Content --> */}
                 <main id="main-content" className="flex-1 px-10 py-8">
                   {/* <!-- Header --> */}
            <Header title="Vendor Detail #123456" />
            <form>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 p-8 bg-white">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Name*</label>
                                        <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Type</label>
                                        <select className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                                            <option>Manufacturer</option>
                                            <option>Distributor</option>
                                            <option>Wholesaler</option>
                                            <option>Retailer</option>
                                            <option>Other</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Contact Person*</label>
                                        <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Email Address*</label>
                                        <input type="email" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number*</label>
                                        <input type="tel" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Website</label>
                                        <input type="url" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                                    </div>
                                {/* </div> */}
                                
                                <div className="mb-6">
                                    <h4 className="text-md font-medium text-gray-800 mb-3">Address Information</h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Street Address*</label>
                                            <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">City*</label>
                                            <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">State/Province*</label>
                                            <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Postal Code*</label>
                                            <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Country*</label>
                                            <select className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required="">
                                                <option>United States</option>
                                                <option>Canada</option>
                                                <option>United Kingdom</option>
                                                <option>Australia</option>
                                                <option>Germany</option>
                                                <option>France</option>
                                                <option>Japan</option>
                                                <option>Other</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="mb-6">
                                    <h4 className="text-md font-medium text-gray-800 mb-3">Product Information</h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Product Categories</label>
                                            <select multiple="" 
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                                                <option>Medications</option>
                                                <option>Medical Devices</option>
                                                <option>Diagnostic Equipment</option>
                                                <option>Supplements</option>
                                                <option>First Aid</option>
                                                <option>Personal Protective Equipment</option>
                                                <option>Laboratory Supplies</option>
                                            </select>
                                            <p className="text-xs text-gray-500 mt-1">Hold Ctrl/Cmd to select multiple</p>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Certification/Compliance</label>
                                            <div className="space-y-2">
                                                <label className="flex items-center">
                                                    <input type="checkbox" className="rounded text-primary-600 mr-2" />
                                                    <span className="text-sm text-gray-700">FDA Approved</span>
                                                </label>
                                                <label className="flex items-center">
                                                    <input type="checkbox" className="rounded text-primary-600 mr-2" />
                                                    <span className="text-sm text-gray-700">ISO 13485</span>
                                                </label>
                                                <label className="flex items-center">
                                                    <input type="checkbox" className="rounded text-primary-600 mr-2" />
                                                    <span className="text-sm text-gray-700">CE Mark</span>
                                                </label>
                                                <label className="flex items-center">
                                                    <input type="checkbox" className="rounded text-primary-600 mr-2" />
                                                    <span className="text-sm text-gray-700">GMP Certified</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="mb-6">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Additional Notes</label>
                                    <textarea rows="3" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"></textarea>
                                </div>
                                
                                <div className="mb-6">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Status</label>
                                    <div className="flex space-x-4">
                                        <label className="flex items-center">
                                            <input type="radio" name="status" className="text-primary-600 mr-2" checked="" />
                                            <span className="text-sm text-gray-700">Active</span>
                                        </label>
                                        <label className="flex items-center">
                                            <input type="radio" name="status" className="text-primary-600 mr-2" />
                                            <span className="text-sm text-gray-700">Pending</span>
                                        </label>
                                        <label className="flex items-center">
                                            <input type="radio" name="status" className="text-primary-600 mr-2" />
                                            <span className="text-sm text-gray-700">Inactive</span>
                                        </label>
                                    </div>
                                </div>
                                  <div className="pt-2 pb-4 flex justify-end space-x-3">
                                       <Link to="/vendors" class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700" id="cancel-category-modal"> Back</Link>
                                  </div>
                                  </div>
                              </form>
                              </main>
      </div>
  )
}
